'use strict'

const React = require('react')
const classNames = require('classnames')
const propTypes = require('prop-types');
const Helpers = require('../../../../../_plugins/lib/helpers')
const { string, object } = propTypes
const createReactClass = require('create-react-class');

const ParkingTable = createReactClass({
  mixins: [Helpers],

  propTypes: {
    id: string.isRequired,
    location: object,
    domainSettings: object,
    settings: object
  },

  shouldComponentUpdate () {
    return false
  },

  getCurrentTable () {
    const { id } = this.props
    if (typeof window === 'undefined') return null
    const element = this.$('#' + id)
    if (!element) return null
    return element.innerHTML
  },

  getTableDataFromFeed () {
    const { location } = this.props
    if (!location) return this.getCurrentTable()
    try {
      let tableData = require('../../../../../config/exports/parkingLocations/' + location.code + '.json')
      tableData = this.makeTableObject(tableData)
      const tableInfo = {
        offAirport: tableData.offAirport,
        onAirport: tableData.onAirport,
        meetAndGreet: tableData.meetAndGreet
      }
      return this.makeTable(tableInfo)
    } catch (e) {
      return this.getCurrentTable()
    }
  },

  getTableHeaders () {
    return (
      <tr>
        <th className='firsttd' />
        <th className='hidden-xs' />
        <th>Car Park</th>
        <th className='hidden-xs'>Rating</th>
        <th>Transfer Time</th>
        <th className='hidden-xs'>Keep Keys</th>
        <th>8 Day Price</th>
      </tr>
    )
  },

  // Create each table row object how we need it
  makeTableObject (tableData) {
    const { domainSettings } = this.props
    return Object.keys(tableData).reduce((output, key) => {
      const item = tableData[key]
      if (!item || !item.prodlib) return output
      let {
        tripappcarparkname,
        tripapphotelname,
        tripappaddonname,
        name,
        keep_keys: keepKeys,
        on_airport: onAirport,
        meet_and_greet: meetAndGreet,
        transfer_time: transferTime,
        seo_page_product_name: seoProductName,
        seo_page_transfer_time: seoTransferTime,
        _prodcode
      } = item.prodlib

      const productName = seoProductName || tripappcarparkname || tripapphotelname || tripappaddonname || item.title || name
      const pageName = item.pagename && item.pagename.replace('"', '')
      const keepKeysClass = classNames({
        'greenkey': parseInt(keepKeys, 10),
        'redkey': !parseInt(keepKeys, 10)
      })
      keepKeys = parseInt(keepKeys, 10) ? 'Yes' : 'No'
      onAirport = parseInt(onAirport, 10)
      meetAndGreet = parseInt(meetAndGreet, 10)
      const type = classNames({
        'meetAndGreet': meetAndGreet,
        'onAirport': (!meetAndGreet && onAirport),
        'offAirport': (!onAirport && !meetAndGreet)
      })

      if (item.prodlib.logo && item.prodlib.logo !== '') {
        item.logo = domainSettings.contentStaticServer + item.prodlib.logo.replace('imageLibrary/Images', 'libraryimages')
      } else {
        if (item.logo && item.logo.substr(0, 2) !== '//' && item.logo.substr(0, 4) !== 'http') {
          item.logo = domainSettings.contentStaticServer + item.logo
        }
      }

      let transferText = 'Within walking distance'
      let transferType = 'service_walk'
      if (meetAndGreet) {
        transferText = 'Met at Airport'
        transferType = 'service_met'
      } else if (transferTime || seoTransferTime) {
        transferText = (seoTransferTime) ? seoTransferTime + ' mins' : transferTime + ' mins'
        transferType = 'service_bus'
      }

      let averageRating = null
      if (item.score && item.score.average) {
        averageRating = (item.score.average * 2)
      }

      if (!output[type]) output[type] = [ ]
      output[type].push({
        productName,
        _prodcode,
        pageName,
        logo: item.logo,
        linkTitle: seoProductName || item.title || name,
        keepKeys,
        keepKeysClass,
        score: item.score,
        averageRating,
        transferText,
        transferType,
        reviewsLink: (item.links && item.links.reviews ? item.links.reviews : null),
        price: item.price,
        priceUnits: (item.price ? item.price.per_week : null)
      })
      return output
    }, { })
  },

  tableTitle (type) {
    if (!type) return ''
    if (type === 'onAirport') return 'On-Airport Parking'
    if (type === 'offAirport') return 'Off-Airport Parking'
    if (type === 'meetAndGreet') return 'Meet and Greet Airport Parking'
    return type
  },

  makeTable (tableRows = { }) {
    const tableHeaders = this.getTableHeaders()
    return Object.keys(tableRows).map(type => {
      if (!tableRows[type]) return null
      const tableContents = this.makeTableRow(tableRows[type])
      const tableTitle = this.tableTitle(type)
      return (
        <table key={type} className='table table-condensed product-table-slim'>
          <caption>{ tableTitle }</caption>
          <thead>
            { tableHeaders }
          </thead>
          <tbody>
            { tableContents }
          </tbody>
        </table>
      )
    })
  },

  makeTableRow (tableRows = [ ]) {
    const { settings } = this.props
    return tableRows.map((tableRow, key) => {
      return (
        <tr key={key} data-productcode={tableRow._prodcode}>
          <td className='firsttd' />
          <td className='hidden-xs' width='105'>
            <img data-original={tableRow.logo} className='hidden-xs' alt={tableRow.productName} />
          </td>
          <td>
            { tableRow.pageName ? (
              <a href={tableRow.pageName} title={tableRow.linkTitle}>{ tableRow.linkTitle }</a>
              ) : tableRow.productName }
          </td>
          <td className='text-center hidden-xs'>
            { tableRow.averageRating ? (
              <span className='review'>{ tableRow.averageRating }/10</span>
            ) : 'No rating' }
            { tableRow.averageRating && tableRow.reviewsLink && <a href={tableRow.reviewsLink} title='customer reviews'><span> reviews</span></a>}
          </td>
          <td className='text-center'>
            <span className={tableRow.transferType} />
            { tableRow.transferText }
          </td>
          <td className='text-center miles hidden-xs'>
            <span className={tableRow.keepKeysClass} />
            { tableRow.keepKeys }
          </td>
          <td className='text-center tablePrice'>
            { tableRow.priceUnits && (
              <span>
                { settings.priceFormat + tableRow.priceUnits + '*' }
                <a href='#' className='tooltip'>
                  <span className='tooltipText'>{ 'This is a guide price for reservations between ' + tableRow.price.startDate + ' and ' + tableRow.price.endDate + ', valid at 12am on ' + tableRow.price.dateUsed }</span>
                  { '(?)' }
                </a>
              </span>
            ) || (
              'Please search for availability'
            )}
          </td>
        </tr>
      )
    })
  },

  render () {
    const { id } = this.props
    const tableContents = this.getTableDataFromFeed()

    if (!tableContents) {
      return (
        <span id={id} />
      )
    }
    if (typeof tableContents !== 'string') {
      return (
        <div id={id}>
          { tableContents }
          * Live airport parking prices are constantly changing according to supplier availability and pricing and, as such, may be different to the prices advertised here.  We do our best to display the most relevant, up-to-date prices here using example dates and times (specified within the '(?)' ) which is always the cheapest 8 day period within the next 61 days.
        </div>
      )
    }
    return (
      <div id={id} dangerouslySetInnerHTML={{ __html: tableContents }} />
    )
  }
})

module.exports = ParkingTable





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/tables/parkingTable.jsx